import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { getRewardsAccounts } from "../../../../modules/rewards/reducer";
import {
  getCreditBreakdown,
  getTravelWalletCredit,
  getTravelWalletCreditHistory,
} from "../../../../modules/travel-wallet/reducer";
import { IStoreState } from "../../../../reducers/types";
import { WalletTravelCreditBalanceCard } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  credit: getTravelWalletCredit(state),
  creditBreakdown: getCreditBreakdown(state),
  creditTransactionHistory: getTravelWalletCreditHistory(state),
  rewardsAccounts: getRewardsAccounts(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type WalletTravelCreditBalanceCardConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedWalletTravelCreditBalanceCard = connector(
  withRouter(WalletTravelCreditBalanceCard)
);
